
import './App.css';
import MainView from './views/MainView';


function App() {
  return (
        <div>

        {/* Main */}
        <MainView/>
        </div>
  );
}


export default App;
